import { Users, UserCircle } from 'lucide-react';

import { CRMRootLayout } from './_components/_layouts/CRMRootLayout';
import { AccountDetailsView } from './_components/accounts/_AccountDetailsView';
// import { AccountFormDialog } from './_components/accounts/_AccountFormDialog';
import { AccountListView } from './_components/accounts/_AccountListView';
import { crmRoutes } from './routes';

import { createAppModule } from '~/shared/routing/createAppModule';
import { createModuleNav } from '~/shared/routing/createModuleNav';
import { createModuleRoutes } from '~/shared/routing/createModuleRoutes';

export const routeDefs = createModuleRoutes({
  root: {
    path: crmRoutes.root,
    label: (t) => t.menu.crm.root,
    icon: Users,
  },
  accountList: {
    path: crmRoutes.accountList,
    label: (t) => t.menu.crm.accounts.root,
    icon: UserCircle,
    component: AccountListView,
    requiredPermission: 'accountRead',
  },
  accountDetails: {
    path: crmRoutes.accountDetails,
    component: AccountDetailsView,
  },
});

// prettier-ignore
const crmNav = createModuleNav(($) =>
  $(routeDefs.root, [
    $(routeDefs.accountList),
    $(routeDefs.accountDetails),
  ]),
);

export const crmModule = createAppModule({
  routes: routeDefs,
  nav: crmNav,
  layout: CRMRootLayout,
});
